import dayjs from 'dayjs';
import { Statistics } from 'shared/model/statistic.model';
import Metric from 'shared/routes/components/Metric/Metric';

type Props = {
  stats?: Statistics;
};

const AverageTimeSpentMetric = ({ stats }: Props) => {
  let nb = 0;
  if (stats) {
    const sumTimespent = stats.usersConnections.reduce((acc, c) => acc + c.timespent, 0);
    nb = sumTimespent / stats.usersConnections.length;
  }

  const metric = dayjs.duration(nb, 'seconds').humanize();

  return <Metric label="Average time spent on application">{metric}</Metric>;
};

export default AverageTimeSpentMetric;
